// extracted by mini-css-extract-plugin
module.exports = {"layout":"ngcommon-module--layout--56Aq3"};